<template lang="pug">
.article-list-item
  router-link(:to="{ name: 'article', params: { id: article.key } }")
    article
      h3.is-size-5.has-font-weight-semibold {{ article.title }}
      p {{ article.pub_date | date }}
</template>

<script>
export default {
  name: 'article-list-item',
  computed: {
    article() {
      return this.value;
    },
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss">
.article-list-item {
  article {
    background-color: $white;
    padding: 1rem;
  }
}
</style>
